import { render, staticRenderFns } from "./lessonBatchTemplate.vue?vue&type=template&id=67eec959&scoped=true&"
import script from "./lessonBatchTemplate.vue?vue&type=script&lang=js&"
export * from "./lessonBatchTemplate.vue?vue&type=script&lang=js&"
import style0 from "./lessonBatchTemplate.vue?vue&type=style&index=0&id=67eec959&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67eec959",
  null
  
)

export default component.exports